export default __webpack_public_path__ + "static/integrations-0fd0d2309e02228dc8dfddf6b4839357.svg";